/**
 * 计算字符串的 hash 值
 */
export function hashString(str) {
    var hash = 0;
    if (str.length === 0) {
        return String(hash);
    }
    for (var i = 0, len = str.length; i < len; i += 1) {
        var chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        // Convert to 32bit integer
        hash |= 0;
    }
    return String(hash).replace('-', '0');
}
